import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Pages/Config";

const UserHighestBid = ({ itemId, userId }) => {
    const [bid, setBid] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!itemId || !userId) return;

        const fetchBid = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/get-highest-bid-user.php`, {
                    params: { itemId, userId },
                });

                // console.log("bid", response);

                if (response.data && response.data.highestBid) {
                    setBid(response.data.highestBid);
                } else {
                    setBid(0);
                }
            } catch (err) {
                console.error("Error fetching bid:", err);
                setBid(0);
            } finally {
                setLoading(false);
            }
        };

        fetchBid();
    }, [itemId, userId]);

    if (loading) return <p>Loading...</p>;

    return (
        <div className="details_buyer">
            <h6>User Bid</h6>
            <p style={{ color: "#ebc32f", fontWeight: "800" }}>
                {bid} SAR
            </p>
        </div>
    );
};

export default UserHighestBid;
